/* eslint-disable */ 
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Table, Row, Col } from 'react-bootstrap';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import  Navwrapper  from '../../layout/Navigation';
import Footer from '../../layout/Footer';
import { getSeasonsRankingByPlayer, getPlayerProfileBySeason } from '../api'
import { exportCSV, tableOptions,getNum} from '../common'
import {PlayerProfileHeaders}  from '../../../utils/constants';
export default class PlayerProfilePage extends Component {

    constructor(props) {
        super(props);
        const { match } = this.props
        this.state = {
            currentSeason:"",
             profileData:[],
             seasons:[],
             playerName:"",
             schoolName:"",
             seasonId:match.params.seasonId,
             playerId:match.params.playerId
        };
        this.handleActiveSeasonChange = this.handleActiveSeasonChange.bind(this)
        this.setActiveSeasonsOptions  = this.setActiveSeasonsOptions.bind(this)             
      }    

    componentDidMount() {
      const { seasonId, playerId } = this.state;

      getSeasonsRankingByPlayer(playerId).then((response) => {
        const seasons = response.data;
        const selectedSeason = seasons.find(s => s.seasonId === parseInt(seasonId));

        this.setState({
          seasons,
          currentSeason: selectedSeason ? selectedSeason.seasonName : seasons[0].seasonName,
        });

        getPlayerProfileBySeason(seasonId, playerId).then((response) => {
          this.setState({
            profileData: response.data,
            playerName: response.data[0].playerName,
            schoolName: response.data[0].schoolName,
          });
        });
      });
    }      
      
  eventNameFormatter(cell, row,state ) {
    var linkMen = `/eventAverage/${row.seasonId}/${row.eventId}/${row.event}/${state.currentSeason}/true`;
    var linkWomen = `/eventAverage/${row.seasonId}/${row.eventId}/${row.event}/${state.currentSeason}/true`;
    var link = `/eventAverage/${row.seasonId}/${row.eventId}/${row.event}/${state.currentSeason}/true`;
    return (<Link to={link}>{cell}</Link>);      
  }   
  
  setActiveSeasonsOptions()
    {
      const { seasons, seasonId } = this.state
      const option = seasons.map((season) => {
        return (<option value={season.seasonId} key={season.seasonId} defaultValue={seasonId}>{season.seasonName}</option>)
      })
      return option
    } 

  handleActiveSeasonChange(event) {
    const seasonId = event.target.value;
    const selectedSeason = this.state.seasons.find(s => s.seasonId === parseInt(seasonId));

    this.setState({
      seasonId,
      currentSeason: selectedSeason ? selectedSeason.seasonName : this.state.currentSeason,
    });

    getPlayerProfileBySeason(seasonId, this.state.playerId).then((response) => {
      this.setState({
        profileData: response.data,
        playerName: response.data[0].playerName,
        schoolName: response.data[0].schoolName,
      });
    });
  }

  totals_SplitData_Row(profileData,tierNo) {
    //console.log("profileData: ",profileData);
    var filteredTier;
    var tierLabel;
    if ( tierNo === 0 ){
       filteredTier = profileData; 
       tierLabel="TOTAL: All Events";
    } 
    else {
        filteredTier = profileData.filter( (dataItem) => (dataItem.tr === tierNo) ); 
        tierLabel="SPLIT: Tier "+tierNo+" Events";
    }
    
    const totTierSum = filteredTier.reduce( function(cnt,i){ return cnt + i.total; },0);    
    const totGmSum = filteredTier.reduce( function(cnt,i){ return cnt + i.gm; },0);   
    const totAvg = (totTierSum/totGmSum).toFixed(3);
    const sumFATotP = filteredTier.reduce( function(cnt,i){ return cnt + (((i.adiff-i.avg)*-1)*i.gm); },0)
    const totADiff = ( (totTierSum/totGmSum) - (sumFATotP/totGmSum) ).toFixed(3);
    //console.log("( totAvg -(sumFATotP/totGmSum) ).toFixed(6);",( (totTierSum/totGmSum) -(sumFATotP/totGmSum) ).toFixed(6))
    const totTop1 = filteredTier.reduce( function(cnt,i){ return cnt + i.top1; },0);    
    const totTop5 = filteredTier.reduce( function(cnt,i){ return cnt + i.top5; },0);    
    const totTop10 = filteredTier.reduce( function(cnt,i){ return cnt + i.top10; },0);    
    const totTop25 = filteredTier.reduce( function(cnt,i){ return cnt + i.top25; },0);    
    
    return <tr >      
              <td>{tierLabel}</td>
              <td></td>
              <td></td>
              <td>{getNum(totTierSum)}</td>
              <td>{getNum(totGmSum)}</td>
              <td>{getNum(totAvg)}</td>
              <td>--</td>
              <td>--</td>
              <td>--</td>
              <td>{getNum(totADiff)}</td>
              <td>{getNum(filteredTier.length)}</td>
              <td>{getNum(totTop1)}</td>
              <td>{getNum(totTop5)}</td>
              <td>{getNum(totTop10)}</td>
              <td>{getNum(totTop25)}</td>
              <td></td>
          </tr>
  }

  render() {  
    const {profileData}=this.state; 
    const {playerName}=this.state;
    const {schoolName}=this.state;
    //const {playerId}=this.state;

  return (
    <div>
      <Navwrapper />      
      <div className="container-fluid">
        <Row>
          <div className="pageHeading" >
              <h4>College Bowling</h4>
                <h4 >
                        Player Profile
                </h4>
                <div className="archiveDropDown">
                      <div >
                        <div className="titleWrap">
                          <label className="archiveLabel">Season: </label>
                        </div>
                        <div className="valueWrap" >
                    <select
                      value={this.state.seasonId}
                      onChange={this.handleActiveSeasonChange}
                    >
                              {this.setActiveSeasonsOptions()}
                            </select>
                        </div>
                      </div>
                  </div>                  
          </div>
        </Row>    

        <Row >
          <Col xs={3}>                                                
            <Table className="totals_table"  >
              <thead >
                <tr >
                  <th>
                    Player Profile  
                  </th>
                  <th/>
                  <th/>
                  <th/>                                    
                </tr>
              </thead>
              <tbody>

                <tr >
                  <td className="totals_background" >Player:</td>
                  <td>{playerName}</td>                          
                {/* </tr>                   
                <tr > */}
                  <td className="totals_background" >School:</td>
                  <td>{schoolName}</td>                          
                </tr> 
                <tr >
                  <td className="totals_background" >Class Year:</td>
                  <td>N/A</td>                          
                {/* </tr>   
                <tr > */}
                  <td className="totals_background" >Hometown:</td>
                  <td>N/A</td>                          
                </tr>                                                                         
              </tbody>
            </Table>
          </Col>
        </Row>    

        <Row className="blank_row" />  

        <Row>                            
              <Col xs={12} >                           
                <div > 
                  <BootstrapTable 
                    data={profileData} 
                    striped 
                    hover 
                    options={tableOptions}
                    pagination               
                  >
                      <TableHeaderColumn          
                        dataField="Id" 
                        isKey 
                        dataAlign="right" 
                        dataSort 
                        data-Visible="false"               
                        hidden                 
                      >ID
                      </TableHeaderColumn>
                      <TableHeaderColumn 
                        dataField="event" 
                        dataSort  
                        dataFormat={this.eventNameFormatter} 
                        formatExtraData={this.state}
                        width="10%" 
                      >EVENT
                      </TableHeaderColumn>                   
                      <TableHeaderColumn dataField="tr" dataSort width="2%" >TR
                      </TableHeaderColumn>
                      <TableHeaderColumn dataField="dv" dataAlign="right"  width="2%" >DV
                      </TableHeaderColumn>
                      <TableHeaderColumn dataField="total" dataAlign="right"  width="5%" >TOTAL
                      </TableHeaderColumn>
                      <TableHeaderColumn dataField="gm" dataAlign="right"  width="2%" >GM
                      </TableHeaderColumn>
                      <TableHeaderColumn dataField="avg" dataAlign="right"  width="6%" >AVG
                      </TableHeaderColumn>
                      <TableHeaderColumn dataField="pos" dataAlign="right"  width="2%" >POS
                      </TableHeaderColumn>
                      <TableHeaderColumn dataField="bwl" dataAlign="right"  width="2%" >BWL
                      </TableHeaderColumn>
                      <TableHeaderColumn dataField="tms" dataAlign="right"  width="2%" >TMS
                      </TableHeaderColumn>
                      <TableHeaderColumn dataField="adiff" dataAlign="right"  width="6%" >A-DIFF
                      </TableHeaderColumn>
                      {/* <TableHeaderColumn dataField="e" dataAlign="right"  width="2%" >E
                      </TableHeaderColumn>                     */}
                      <TableHeaderColumn dataField="top1" dataAlign="right"  width="2%" >1
                      </TableHeaderColumn>       
                      <TableHeaderColumn dataField="top5" dataAlign="right"  width="2%" >5
                      </TableHeaderColumn>                                      
                      <TableHeaderColumn dataField="top10" dataAlign="right"  width="2%" >10
                      </TableHeaderColumn>                                      
                      <TableHeaderColumn dataField="top25" dataAlign="right"  width="2%" >25
                      </TableHeaderColumn>                                                  
                      <TableHeaderColumn dataField="pct" dataAlign="right"  width="6%" >PCT
                      </TableHeaderColumn>
                  </BootstrapTable>              
                </div>
              </Col>
        </Row>
        <Row>
        { exportCSV(profileData,PlayerProfileHeaders,'Player profile - '+schoolName+' - '+ playerName+'.csv') }
        </Row>
        <Row>
          <Col xs={3} />   
          <Col xs={6}  className="totals_table" >
            <Table  className="table_greybackground">
                <thead >
                    <th></th>
                    <th></th>
                    <th></th>
                    <th>TOTAL</th>
                    <th>GM</th>
                    <th>AVG</th>
                    <th>--</th>
                    <th>--</th>
                    <th>--</th>
                    <th>A-DIFF</th>
                    {/* <th>E</th> */}
                    <th>1</th>
                    <th>5</th>
                    <th>10</th>
                    <th>25</th>
                    <th></th>                            
                </thead> 
                <tbody>
                    {this.totals_SplitData_Row(profileData,1)}
                    {this.totals_SplitData_Row(profileData,2)}
                    <Row className="blank_row" />
                    {this.totals_SplitData_Row(profileData,0)}
                </tbody>
            </Table>
          </Col>
        </Row>
        <Row className="blank_row" /> 
        <Row className="blank_row" /> 
        <Row  >
          <Col xs={3} />
          <Col xs={6}  className="totals_background legend_background">

            <b>EVENT</b> - event name / <b>TR</b> - event tier (Tier 1 or Tier 2) / <b>DV</b> 
            - division (varisty or junior varsity)<br/>
            <b>TOTAL</b> - total pins of player / <b>GM</b> - # of games bowled by player / 
            <b>AVG</b> - average of player<br/>
            <b>POS</b> - field position of player / <b>BWL</b> - # of bowlers in field / 
            <b>TMS</b> - # of teams in field<br/>
            <b>A-DIFF</b> - average differential / 
            {/* <b>E</b> - # of events bowled /  */}
            <b> 1 5 10 25</b> - # of finishes at #1 or in top 5, 10, and 25<br/>
            <b>PCT</b> - percentage of field beaten (by total pins) / if *
              appears not all games bowled<br/>
            <br/>
            If a line appears below "TOTAL", it lists the name of a conference, total pins of player,<br/>
            # of games bowled by player, average of player, and all conference awards won by player, if any          

          </Col>
        </Row>
      </div>
      <Row className="blank_row"/>
      <Footer />
    </div>    
  );
  }
}


// WEBPACK FOOTER //
// ./src/components/pages/playerProfile/index.js